<template >
  <div class="classDialog">
    <el-dialog
      title="新增关联"
      :visible.sync="classDialogVisible"
      width="500px"
      :close-on-click-modal="false"
    >
      <el-select v-model="typeId" placeholder="请选择">
        <el-option
          v-for="item in shijuanType"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        >
        </el-option>
      </el-select>
      <div slot="footer" class="dialog-footer">
        <el-button @click="classDialogVisible = false">关闭</el-button>
        <el-button type="primary" @click="save()">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script type="text/babel">
export default {
  props: {
    types: {
      type: Array,
      default: []
    },
    value: {
      type: Boolean,
      default () {
        return false
      }
    }
  },
  methods: {
    save() {
      if (!this.typeId) {
        this.$message.error('请选择类型');
        return;
      }
      this.$emit('success', this.typeId)
    }
  },
  data () {
    return {
      typeId: '',
      shijuanType: []
    }
  },
  watch: {
    classDialogVisible (newVal, oldVal) {
      if (newVal) {
        console.log(this.$props.types);
        this.shijuanType = this.$props.types
      }
    }
  },
  computed: {
    classDialogVisible: {
      get () {
        return this.value;
      },
      set (val) {
        this.$emit('input', val);
      }
    }
  }
}
</script>
<style scoped>
  .classDialog .el-select{
    width: 100%;
  }
</style>
<style type="text/css">

</style>



// WEBPACK FOOTER //
// src/pages/layout/shijuan-manage/edit-dialog/link.vue